export var linkHaveChildren = function (row) { return !!(row && row.__children && row.__children.length); };
export var debounce = function (func) {
    var timer;
    return function (event) {
        if (timer) {
            clearTimeout(timer);
        }
        timer = window.setTimeout(func, 100, event);
    };
};
//# sourceMappingURL=Banner.functions.js.map